import {
    SET_USER,
    SET_TOKEN,
    SET_FILTER_USER
} from "../../action/login";

const user = {
    user: {
        filter: {
            findByCompanyId: false
        }
    },
    token: {
        token: "",
        refreshToken: ""
    }
}

function currentUser(state = {...user}, action) {
    switch (action && action.type) {
        case SET_USER:
            state.user = {...user.user, ...action.data.user};
            return {...state};
        case SET_FILTER_USER:
            state.user.filter = action.data;
            return {...state};
        case SET_TOKEN:
            state.token.token = action.data;
            return state;
        default:
            return state;
    }
}

export default currentUser;

